!function (t, e) {
  "object" == typeof exports && "object" == typeof module ? module.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports["@hotmart/cosmos"] = e() : t["@hotmart/cosmos"] = e();
}(self, function () {
  return (() => {
    "use strict";

    var t = {
        7705: t => {
          t.exports = function (t) {
            var e = [];
            return e.toString = function () {
              return this.map(function (e) {
                var r = "",
                  a = void 0 !== e[5];
                return e[4] && (r += "@supports (".concat(e[4], ") {")), e[2] && (r += "@media ".concat(e[2], " {")), a && (r += "@layer".concat(e[5].length > 0 ? " ".concat(e[5]) : "", " {")), r += t(e), a && (r += "}"), e[2] && (r += "}"), e[4] && (r += "}"), r;
              }).join("");
            }, e.i = function (t, r, a, o, n) {
              "string" == typeof t && (t = [[null, t, void 0]]);
              var i = {};
              if (a) for (var s = 0; s < this.length; s++) {
                var c = this[s][0];
                null != c && (i[c] = !0);
              }
              for (var l = 0; l < t.length; l++) {
                var u = [].concat(t[l]);
                a && i[u[0]] || (void 0 !== n && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = n), r && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = r) : u[2] = r), o && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = o) : u[4] = "".concat(o)), e.push(u));
              }
            }, e;
          };
        },
        6738: t => {
          t.exports = function (t) {
            return t[1];
          };
        },
        7452: (t, e, r) => {
          r.d(e, {
            Z: () => s
          });
          var a = r(6738),
            o = r.n(a),
            n = r(7705),
            i = r.n(n)()(o());
          i.push([t.id, ":host{-webkit-box-align:center;-webkit-align-items:center;-moz-box-align:center;-ms-flex-align:center;align-items:center;background-position:center center;background-repeat:no-repeat;-moz-background-size:cover;background-size:cover;-webkit-border-radius:0;-moz-border-radius:0;border-radius:0;display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;font-style:normal;font-weight:var(--font-weight-light, 300);height:var(--avatar-md, 2rem);-webkit-box-pack:center;-webkit-justify-content:center;-moz-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:var(--avatar-md, 2rem);overflow:hidden;padding:0;position:relative;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:var(--avatar-md, 2rem)}:host ::slotted(img){height:100%;left:0;position:absolute;top:0;width:100%}:host ::slotted(span){position:relative;text-align:center}:host(.hot-avatar--rounded){-webkit-border-radius:var(--border-radius, 0.25rem);-moz-border-radius:var(--border-radius, 0.25rem);border-radius:var(--border-radius, 0.25rem)}:host(.hot-avatar--circle){-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%}:host(.hot-avatar--text){background-color:var(--primary, #5981e3);color:var(--white, #ffffff)}:host(.hot-avatar--text) ::slotted(span){font-size:var(--text-2, 1rem)}:host(.hot-avatar--xs){height:var(--avatar-xs, 1rem);min-width:var(--avatar-xs, 1rem);width:var(--avatar-xs, 1rem)}:host(.hot-avatar--xs) ::slotted(span){font-size:-webkit-calc(var(--text-1, 0.75rem) - var(--text-1, 0.75rem)/4);font-size:-moz-calc(var(--text-1, 0.75rem) - var(--text-1, 0.75rem)/4);font-size:calc(var(--text-1, 0.75rem) - var(--text-1, 0.75rem)/4);top:var(--component-border-width, 0.0625rem)}:host(.hot-avatar--sm){height:var(--avatar-sm, 1.5rem);min-width:var(--avatar-sm, 1.5rem);width:var(--avatar-sm, 1.5rem)}:host(.hot-avatar--sm) ::slotted(span){font-size:var(--text-1, 0.75rem)}:host(.hot-avatar--md){height:var(--avatar-md, 2rem);min-width:var(--avatar-md, 2rem);width:var(--avatar-md, 2rem)}:host(.hot-avatar--md) ::slotted(span){font-size:var(--text-2, 1rem)}:host(.hot-avatar--lg){height:var(--avatar-lg, 2.5rem);min-width:var(--avatar-lg, 2.5rem);width:var(--avatar-lg, 2.5rem)}:host(.hot-avatar--lg) ::slotted(span){font-size:var(--text-3, 1.25rem)}:host(.hot-avatar--xl){height:var(--avatar-xl, 3rem);min-width:var(--avatar-xl, 3rem);width:var(--avatar-xl, 3rem)}:host(.hot-avatar--xl) ::slotted(span){font-size:var(--text-4, 1.5rem)}:host(.hot-avatar--xxl){height:var(--avatar-xxl, 6rem);min-width:var(--avatar-xxl, 6rem);width:var(--avatar-xxl, 6rem)}:host(.hot-avatar--xxl) ::slotted(span){font-size:var(--text-8, 2.5rem)}", ""]);
          const s = i;
        },
        5097: (t, e, r) => {
          r.d(e, {
            Z: () => s
          });
          var a = r(6738),
            o = r.n(a),
            n = r(7705),
            i = r.n(n)()(o());
          i.push([t.id, ':host{font-family:var(--font-family, "Nunito Sans", -apple-system, blinkmacsystemfont, "Segoe UI", helvetica, arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol")}:host *,:host *::before,:host *::after{-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box}', ""]);
          const s = i;
        }
      },
      e = {};
    function r(a) {
      var o = e[a];
      if (void 0 !== o) return o.exports;
      var n = e[a] = {
        id: a,
        exports: {}
      };
      return t[a](n, n.exports, r), n.exports;
    }
    r.n = t => {
      var e = t && t.__esModule ? () => t.default : () => t;
      return r.d(e, {
        a: e
      }), e;
    }, r.d = (t, e) => {
      for (var a in e) r.o(e, a) && !r.o(t, a) && Object.defineProperty(t, a, {
        enumerable: !0,
        get: e[a]
      });
    }, r.o = (t, e) => Object.prototype.hasOwnProperty.call(t, e), r.r = t => {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(t, "__esModule", {
        value: !0
      });
    };
    var a = {};
    return (() => {
      r.r(a);
      const t = require("@babel/runtime/helpers/classCallCheck");
      var e = r.n(t);
      const o = require("@babel/runtime/helpers/createClass");
      var n = r.n(o);
      const i = require("@babel/runtime/helpers/get");
      var s = r.n(i);
      const c = require("@babel/runtime/helpers/inherits");
      var l = r.n(c);
      const u = require("@babel/runtime/helpers/possibleConstructorReturn");
      var d = r.n(u);
      const v = require("@babel/runtime/helpers/getPrototypeOf");
      var h = r.n(v);
      const m = require("@babel/runtime/helpers/wrapNativeSuper");
      var f = r.n(m),
        p = r(5097);
      var b = function (t) {
        l()(i, t);
        var r,
          a,
          o = (r = i, a = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = h()(r);
            if (a) {
              var o = h()(this).constructor;
              t = Reflect.construct(e, arguments, o);
            } else t = e.apply(this, arguments);
            return d()(this, t);
          });
        function i(t) {
          var r;
          e()(this, i);
          var a = (r = o.call(this)).getTemplate(),
            n = document.createElement("template");
          n.innerHTML = a;
          var s = n.content.querySelector("style");
          return s && (s.innerHTML = "".concat(s.innerHTML, " ").concat(p.Z.toString())), window.ShadyCSS && window.ShadyCSS.prepareTemplate(n, t), r.attachShadow({
            mode: "open"
          }), r.shadowRoot.appendChild(document.importNode(n.content, !0)), r;
        }
        return n()(i, [{
          key: "connectedCallback",
          value: function () {
            window.ShadyCSS && window.ShadyCSS.styleElement(this);
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "";
          }
        }]), i;
      }(f()(HTMLElement));
      const x = b;
      var g,
        y,
        w = "hot-avatar",
        k = "src",
        S = r(7452);
      g = w, y = function (t) {
        l()(i, t);
        var r,
          a,
          o = (r = i, a = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (t) {
              return !1;
            }
          }(), function () {
            var t,
              e = h()(r);
            if (a) {
              var o = h()(this).constructor;
              t = Reflect.construct(e, arguments, o);
            } else t = e.apply(this, arguments);
            return d()(this, t);
          });
        function i() {
          return e()(this, i), o.call(this, w);
        }
        return n()(i, [{
          key: "connectedCallback",
          value: function () {
            s()(h()(i.prototype), "connectedCallback", this).call(this);
            var t = this.getAttribute(k);
            this._handleSrc(t);
          }
        }, {
          key: "attributeChangedCallback",
          value: function (t, e, r) {
            t === k && this._handleSrc(r);
          }
        }, {
          key: "_handleSrc",
          value: function (t) {
            var e = this;
            if (t) {
              var r = this.getAttribute("role") || "presentation",
                a = this.getAttribute("alt") || "avatar image",
                o = this.querySelector("img");
              o && o.parentNode.removeChild(o), (o = document.createElement("img")).onload = function (t) {
                e.dispatchEvent(new CustomEvent("onload", t));
              }, o.role = r, o.alt = a, o.src = t, this.appendChild(o);
            }
          }
        }, {
          key: "getTemplate",
          value: function () {
            return "\n      <style>".concat(S.Z.toString(), "</style>\n      <slot></slot>\n    ");
          }
        }], [{
          key: "observedAttributes",
          get: function () {
            return [k];
          }
        }]), i;
      }(x), customElements.get(g) || customElements.define(g, y);
    })(), a;
  })();
});